export const TermsOfServiceConfiguration = {
    forceReapprovalOnChange: true,
    listOfRules: [
        `The responsibility for appropriate reuse of information presented
            here remains with the user of the Study Design Suite.`,
        `Approved Roche internal protocols (RIM/eTMF) are continually being
            digitized (verbatim). If you need information that is not presented
            in the Study Design Suite when you select internal studies, please
            contact us at protocol.digitalization@roche.com.`,
    ],
};
